import nodeApiService from "../../../../services/nodeApiService"

export const callArtworksApi = (params, gallery) => {
  if (gallery) {
    return nodeApiService.galleryArtworks(gallery.id, params)
  }

  return nodeApiService.artworks(params)
}
